<template lang="pug">
v-app
  v-container(fill-height)
    v-layout(align-center)
      v-flex(xs12 sm6 class='controls' align-center)
        h3(class='title mb-4') 403 Forbidden
        div(class='font-weight-light')
          | Сервер понял запрос, но он отказывается его выполнять из-за
          | каких-то ограничений в доступе. Идентификация через протокол HTTP
          | здесь не поможет. Скорее всего, на сервере нужно провести
          | аутентификацию другим способом, сделать запрос с определёнными
          | параметрами или удовлетворить каким-либо условиям.
        v-divider(class='my-4')
        v-btn(
          @click='$router.go(-1)'
          color='primary'
          depressed
        )
          v-icon(left) keyboard_backspace
          span Вернуться назад
        v-btn(
          @click='$router.push({ name: "Auth.Login" })'
          color='primary'
          flat
        )
          span Авторизация
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.controls >>> [class*='v-btn--depressed'] {
  margin-left: 0;
}
</style>
